import { Select } from "antd";
import { GlobalOutlined } from "@ant-design/icons";
import { useLocale } from "../contexts/LocaleContext";

export default function LanguageSwitcher() {
  const { locale, setLocale } = useLocale();

  return (
    <Select
      value={locale}
      onChange={setLocale}
      style={{ width: 120 }}
      suffixIcon={<GlobalOutlined />}
    >
      <Select.Option value="zh">中文</Select.Option>
      <Select.Option value="en">English</Select.Option>
    </Select>
  );
}
